export const pdpChoicesSchema = {
  $schema: 'http://json-schema.org/draft-04/schema#',
  type: 'object',

  properties: {
    masterProductSKU: {
      type: 'string',
    },
    isTextile: {
      type: 'boolean',
    },
    productPrintPositions: {
      type: 'array',
      items: { $ref: '#/$defs/printPosition' },
    },
    productVariants: {
      type: 'array',
      items: { $ref: '#/$defs/productColor' },
    },
    productDescription: {
      type: 'string',
    },
  },

  required: [
    'masterProductSKU',
    'isTextile',
    'productPrintPositions',
    'productVariants',
  ],
  additionalProperties: false,

  $defs: {
    productColor: {
      type: 'object',
      properties: {
        variantColor: {
          type: 'string',
        },
        variantColorName: {
          type: 'string',
        },
        colorHex: {
          type: 'string',
        },
        quantity: {
          type: 'integer',
        },
        productName: {
          type: 'string',
        },
      },
      required: [
        'variantColor',
        'variantColorName',
        'colorHex',
        'quantity',
        'productName',
      ],
      additionalProperties: false,
    },

    printPosition: {
      type: 'object',
      properties: {
        printPositionSAPCode: {
          type: 'string',
        },
        printTechniqueSAPCode: {
          type: 'string',
        },
        printTechniqueSAPRangeCode: {
          type: 'string',
        },
        numberOfColors: {
          type: 'integer',
        },
        width: {
          type: 'number',
        },
        height: {
          type: 'number',
        },
        printingCost: {
          type: 'string',
        },
        setupCost: {
          type: 'string',
        },
      },
      required: [
        'printPositionSAPCode',
        'printTechniqueSAPCode',
        'numberOfColors',
      ],
      additionalProperties: false,
    },
  },
};

import { jsonSchemaValidator } from '@/validators';
import { PdpChoicesSetterType } from './typings/index';

export const pdpChoices = {
  type: Object,
  required: false,
  default: (): PdpChoicesSetterType => ({
    masterProductSKU: '',
    isTextile: false,
    productPrintPositions: [
      {
        printPositionSAPCode: '',
        printTechniqueSAPCode: '',
        printTechniqueSAPRangeCode: '',
        numberOfColors: 0,
        width: 0,
        height: 0,
        printingCost: '',
        setupCost: '',
      },
    ],
    productVariants: [
      {
        variantColor: '',
        variantColorName: '',
        colorHex: '',
        quantity: 0,
        productName: '',
      },
    ],
    productDescription: '',
  }),
  validator: (value: JSON): boolean => {
    return (
      jsonSchemaValidator('pdp choices setter', value, pdpChoicesSchema).errors
        .length === 0
    );
  },
};
